// Sentry must initialize before React mounts so it can capture render-time errors.
// Why: previously global errors only logged to the browser console; now they're
// reported externally so we get notified of crashes during the unattended period.
import * as Sentry from '@sentry/react'
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    ignoreErrors: [
      /contentScriptData/,
      /extension:\/\//,
      /chrome-extension:\/\//,
      /moz-extension:\/\//,
      /ResizeObserver loop limit exceeded/,
      /ResizeObserver loop completed with undelivered notifications/,
    ],
  })
}

window.addEventListener('error', (e) => {
  console.error('[GLOBAL ERROR]', e.error?.message, e.error?.stack)
})
window.addEventListener('unhandledrejection', (e) => {
  console.error('[UNHANDLED PROMISE]', e.reason?.message, e.reason?.stack)
})

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import './index.css'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
)